import { isFeatureEnabled } from '@/config/features';

export const useFeatureFlag = (featureName: string): boolean => {
  return isFeatureEnabled(featureName);
};

export default useFeatureFlag; 